import { render, staticRenderFns } from "./StepFive.vue?vue&type=template&id=56e4465e&scoped=true"
import script from "./StepFive.vue?vue&type=script&lang=js"
export * from "./StepFive.vue?vue&type=script&lang=js"
import style0 from "./StepFive.vue?vue&type=style&index=0&id=56e4465e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e4465e",
  null
  
)

export default component.exports